import React from "react";
import Helmet from "react-helmet";
import FormResumen from "../../components/eld/FormResumen";

export default function Resumen() {        
    return (
        <div className="container home">
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div>
                <section>
                    <div className="row w-100 container-padre calculadora">
                        <div className="row">
                            <div className="bloque form">
                                <div className="card formulario">
                                    <div className="card-title textoTitulo">Formulario Selección Modalidad con Excedente de Libre disposición (ELD)</div>
                                    <span className="textoSecundario">Resumen de tu solicitud:</span>
                                    <div className="card-body">
                                        <FormResumen />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}